import { Component, Injector, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../../common/BaseComponent';
import { HttpClient } from '@angular/common/http';
import { AdminService } from 'src/app/service/admin/AdminService';
import { User } from 'src/app/model/user';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';
import { UserRole } from 'src/app/model/userRole';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/util/Constants';
import { ProgressService } from 'src/app/service/ProgressService';
@Component({
  selector: 'admin-select-user-acc',
  templateUrl: './admin-select-user-acc.component.html',
  styles: [
  ]
})
export class SelectUserAccComponent extends BaseComponent implements OnInit {
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;

  restSub: Subscription;
  userDetailsList: any[] = [];
  roleName: string;
  selectedUserEmail: String;
  selectedUserRoleDetails: UserRoleDetails = new UserRoleDetails();
  selectedUser: User = new User();
  selectedUserRole: UserRole = new UserRole();
  appErrorPrefix: string = "bss.api.error";
  validSelection: boolean = false;
  pageMsgRendered: boolean;

  userDetailsPage: any[] = [];
  totalPage: number;
  currentPage: number = 1;

  columnOrder: Map<string, string> = new Map([
    ['firstName', 'asc'],
    ['lastName', 'asc'],
    ['email', 'asc'],
    ['roleStatus', 'asc'],
    ['accountStatus', 'asc']
  ]);

  constructor(
    injector: Injector,
    public rest: AdminService,
    private http: HttpClient,
    public progressService: ProgressService) {
    super(injector);
    this.pageMsgRendered = false;
  }

  ngOnInit(): void {
  }

  search(): void {
    const storedUserDetails = sessionStorage.getItem("searchUserRole");
    if (storedUserDetails) {
      //this.progressService.open();
      const userRoleDetails = JSON.parse(storedUserDetails);
      this.roleName = userRoleDetails.role.roleName;
      this.restSub = this.rest.searchUsers(userRoleDetails.user, this.roleName).subscribe(response => {
        if (response.result > 0) {
          this.appError = true;
          this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;

          if (response.count === 0 || response.count === -1 || response.count > Constants.SEARCH_RESULTS_MAX_ALLOWED) {
            sessionStorage.setItem('userListCount', response.count);
            this.router.navigate(['secure/paadmin/selectUserAccount/error']);
          }
        } else {
          this.appError = false;
          this.userDetailsList = response.userList;
          console.log('Search Result:', this.userDetailsList);
          console.log('response count:', response.count);
          //const numberOfUsers:number = this.userDetailsList.length;
          sessionStorage.setItem('userListCount', response.count);

          const totalRecords = this.userDetailsList.length;
          this.totalPage = Math.ceil(totalRecords / Constants.SEARCH_RESULTS_PER_PAGE);
          console.log("Return " + totalRecords + " records, split it into " + this.totalPage + " pages.");
          this.currentPage = 1;
          this.userDetailsPage = this.userDetailsList.slice(0, Constants.SEARCH_RESULTS_PER_PAGE);
        }
      },
        (error) => {
          this.processError(error)
        },
        () => {
          this.progressService.close();
        }
      );
    }
  }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
    this.progressService.open();
    setTimeout(() => {
      this.search();
    });
  }

  onUserSelected(user: User): void {
    this.selectedUser = user;
    this.validSelection = true;
  }

  // OnSubmit()
  onSubmit(): void {
    this.pageMsgRendered = false;
    this.selectedUserRole.roleName = this.roleName;
    this.selectedUserRoleDetails.user = this.selectedUser;
    this.selectedUserRoleDetails.role = this.selectedUserRole;
    if (this.validSelection) {
      sessionStorage.setItem("selectedUserRole", JSON.stringify(this.selectedUserRoleDetails));
      this.router.navigate(['secure/paadmin/roleMemship']);
    } else {
      this.appError = true;
      this.appErrorMessage = this.getMessage("bss.admin.selectUserAcc.emptyError");
    }
  }

  getPageNumbers(): number[] {
    return Array.from({length: this.totalPage}, (_, index) => index + 1);
  } 

  onPage(pageNum): void {
    if (pageNum >= 1 && pageNum <= this.totalPage) {
      const start = (pageNum - 1) * Constants.SEARCH_RESULTS_PER_PAGE;
      const end = pageNum * Constants.SEARCH_RESULTS_PER_PAGE;
      this.userDetailsPage = this.userDetailsList.slice(start, end);
      this.currentPage = pageNum;
    }
  }

  onSort(event: Event, columnName): void {
    event.preventDefault();

    this.userDetailsList = this.sortUserList(columnName);
    this.toggleSortOrder(columnName);
    this.onPage(1);
  }

  sortUserList(columnName: string): any[] {
    const sortOrder = this.getSortOrder(columnName);

    return this.userDetailsList.sort((a, b) => {
      const valueA = a[columnName];
      const valueB = b[columnName];
  
      if (valueA < valueB) {
        return sortOrder === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return sortOrder === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }

  getSortOrder(columnName: string): string | null {
    return this.columnOrder.has(columnName) ? this.columnOrder.get(columnName) : 'asc';
  }

  toggleSortOrder(columnName: string): void {
    for (const key of this.columnOrder.keys()) {
      if (key === columnName) {
        const currentOrder = this.columnOrder.get(key);
        this.columnOrder.set(key, currentOrder === 'asc' ? 'desc' : 'asc');
      } else {
        this.columnOrder.set(key, 'asc');
      }
    }
  }

  onBack(): void {
    this.router.navigate(['secure/paadmin/role/search']);
  }

  onNewSearch(): void {
    this.newSearch();
  }

  ngAfterViewChecked() {
    if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.pageMsgRendered = true;
    }
  }

  ngOnDestroy() {
    if (this.restSub) {
      this.restSub.unsubscribe();
    }
  }
}